@if (isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
}
@if (!isLoading) {
  <div [innerHTML]="html" class="terms"></div>
}
